import api from '@api'
import {
  buildFlatQualificationStructure,
  buildRelationalQualificationStructure,
} from '@data/qualification'
import {
  // getModulePluaralTranslator,
  getRootPluaralTranslator,
  getRootTranslator,
} from '@utils/get-module-translator'
// import moduleConfig from './config'

import {
  transformRdpConfiguration,
  transformRdpConfigurationForServer,
  transformRdpAgents,
} from '@data/rdp-configuration'
import { successToast } from '@motadata/ui'

// const __tc = getModulePluaralTranslator(moduleConfig.translationKey)
const __rootT = getRootTranslator()
const __rootTc = getRootPluaralTranslator()

export function getRdpConfigurationApi() {
  return api.get(`/asset/rdpsetting`).then(transformRdpConfiguration)
}

export function updateRdpConfigurationApi(data) {
  return api
    .patch(`/asset/rdpsetting`, transformRdpConfigurationForServer(data), {
      message: __rootT('updated_successfully', {
        resource: __rootTc('rdp_configuration'),
      }),
    })
    .then(transformRdpConfiguration)
}

export function rdpConfigurationApi(data) {
  return api.post(`/rdp/fixRdp`, transformRdpConfigurationForServer(data), {
    message: __rootT('configured_successfully', {
      resource: __rootTc('rdp_configuration'),
    }),
  })
}

export function getReloadCertificateApi() {
  return api.get(`/rdp/reloadCertificate`, {
    message: __rootT('updated_successfully', {
      resource: __rootTc('reload_certificate'),
    }),
  })
}

export function getReloadSessionApi() {
  return api.get(`/rdp/updatemaxusersessions`, {
    message: __rootT('updated_successfully', {
      resource: __rootTc('reload_session'),
    }),
  })
}

export function getRdpRecordingFoldersApi() {
  return api.get(`/rdp/recordings/folder`)
}
const deletedQuery = (value) =>
  buildRelationalQualificationStructure(
    'removed',
    'equal',
    value,
    'boolean',
    'db'
  )

// RDP Agent
export function getRdpAgentsApi(searchCriteria, filters, limit, offset) {
  const qualDetails = [...((searchCriteria || {}).quals || [])]
  if ('archived' in filters) {
    qualDetails.push(deletedQuery(true))
  }
  return api
    .post(
      `/rdpagent/search/byqual`,
      {
        qualDetails: qualDetails.length
          ? buildFlatQualificationStructure(qualDetails)
          : undefined,
      },
      {
        params: {
          offset: offset || 0,
          size: limit === undefined ? 1000 : limit,
        },
        notify: false,
      }
    )
    .then((data) => {
      return {
        items: (data.objectList || []).map(transformRdpAgents),
        total: data.totalCount,
      }
    })
}

export function deleteRdpAgentsApi(ids, isPermanentDelete) {
  return api
    .delete(`/rdpagent/bulk/delete`, {
      data: { objectIds: ids },
      params: {
        isPermanentDelete: isPermanentDelete,
      },
    })
    .then((data) => {
      if (data.successIds && data.successIds.length) {
        if (isPermanentDelete === true) {
          successToast(
            `${data.successIds.length} ${__rootT(
              data.successIds.length > 1
                ? 'deleted_successfully_multiple'
                : 'deleted_successfully',
              {
                resource: __rootTc('rdp_agent', data.successIds.length),
              }
            )}`
          )
        } else if (isPermanentDelete === false) {
          successToast(
            `${data.successIds.length} ${__rootT(
              data.successIds.length > 1
                ? 'archived_successfully_multiple'
                : 'archived_successfully',
              {
                resource: __rootTc('rdp_agent', data.successIds.length),
              }
            )}`
          )
        }
      }
      return {
        failed: Object.keys(data.failerIds || {}).map((key) => ({
          id: parseInt(key, 10),
          message: data.failerIds[key].userMessage,
        })),
      }
    })
}

export function restoreRdpAgentsApi(ids) {
  return api
    .patch(`/rdpagent/bulk/restore`, {
      objectIds: ids,
    })
    .then((data) => {
      if (data.successIds && data.successIds.length) {
        successToast(
          `${data.successIds.length} ${__rootT(
            data.successIds.length > 1
              ? 'updated_successfully_multiple'
              : 'updated_successfully',
            {
              resource: __rootTc('rdp_agent', data.successIds.length),
            }
          )}`
        )
      }
      return {
        failed: Object.keys(data.failerIds || {}).map((key) => ({
          id: parseInt(key, 10),
          message: data.failerIds[key].userMessage,
        })),
      }
    })
}
